import Vue from 'vue';
import base from './base';
import router from './router';
import store from './vuex/index';
import toastr from 'toastr';
import WBS from 'js/http';

import { VueMaskDirective } from 'v-mask';
Vue.directive('mask', VueMaskDirective);

import Airbnb from 'vue-airbnb-style-datepicker';
import settinsAirbnb from 'js/settings.airbnb';
Vue.use(Airbnb, settinsAirbnb);
// Import dos css
import './assets/font/stylesheet.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'admin-lte/dist/css/AdminLTE.min.css';
import 'admin-lte/dist/css/skins/_all-skins.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'toastr/build/toastr.min.css';
import './assets/css/style.css';
import 'vue-airbnb-style-datepicker/dist/styles.css';
import 'vue-material/dist/vue-material.min.css';

import VueMaterial from 'vue-material'; // 1. Importar o vue-material

//Incluir e criar variaveis globais
window.$ = window.jQuery = require('jquery');
require('bootstrap/dist/js/bootstrap.min.js');
// require('admin-lte/dist/js/app.min.js')
require('js/form');

Vue.config.productionTip = false;
Vue.prototype.$clone = (data) => JSON.parse(JSON.stringify(data));
Vue.prototype.$msg = toastr;
Vue.prototype.$wbs = WBS;
Vue.prototype.$getImage = function (file, size = 255) {
	let url = 'http://wbs.viasst.com.br/get_image.php';
	return `${url}?file=${file}&size=${size}`;
};

Vue.use(VueMaterial); // 3. Informar ao Vue que utilize o vue-material

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	render: (h) => h(base),
});



// WEBPACK FOOTER //
// ./src/main.js